/* cl-pdp.js — buybox do clone (vanilla): troca de variante com as NOSSAS variantes, galeria
   com miniaturas, estado do botao. O form e o /cart/add do proprio buybox (um so). */
(function () {
  'use strict';

  function init(host) {
    if (host.__clPdp) return;
    host.__clPdp = true;
    var data = host.querySelector('[data-cl-variants]');
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) {}
    var idInput = host.querySelector('form[action*="/cart/add"] input[name="id"]');
    var atc = host.querySelector('button[name="add"]');
    var atcLabel = atc && atc.querySelector('.main-atc__label__text');
    var atcText = atcLabel ? atcLabel.textContent : '';
    /* radios de opcao de variante (os name=quantity do bloco quantity-breaks sao o pack, nao variante) */
    var radios = Array.prototype.slice.call(host.querySelectorAll('input[type="radio"][form^="product-form-"]:not([name="quantity"])'));
    var names = [];
    radios.forEach(function (r) { if (names.indexOf(r.name) === -1) names.push(r.name); });

    function selected() {
      return names.map(function (n) {
        var c = radios.filter(function (r) { return r.name === n && r.checked; })[0];
        return c ? c.value : null;
      });
    }
    function find(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }

    /* ---- galeria ---- */
    var main = host.querySelector('ul[id^="Slider-Gallery-"]');
    var thumbsUl = host.querySelector('ul[id^="Slider-Thumbnails-"]');
    function slides() { return main ? Array.prototype.slice.call(main.children) : []; }
    function goSlide(i, smooth) {
      var s = slides();
      if (!s[i]) return;
      main.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      slides().forEach(function (li, k) { li.classList.toggle('is-active', k === i); });
      if (!thumbsUl) return;
      Array.prototype.forEach.call(thumbsUl.children, function (li, k) {
        var b = li.querySelector('button');
        if (!b) return;
        if (k === i) {
          b.setAttribute('aria-current', 'true');
          var l = li.offsetLeft - thumbsUl.children[0].offsetLeft;
          if (l < thumbsUl.scrollLeft || l + li.offsetWidth > thumbsUl.scrollLeft + thumbsUl.clientWidth) {
            thumbsUl.scrollTo({ left: Math.max(0, l - (thumbsUl.clientWidth - li.offsetWidth) / 2), behavior: 'smooth' });
          }
        } else b.removeAttribute('aria-current');
      });
    }
    if (thumbsUl) {
      thumbsUl.addEventListener('click', function (e) {
        var b = e.target.closest('button.thumbnail');
        if (!b) return;
        e.preventDefault();
        var li = b.closest('li');
        goSlide(Array.prototype.indexOf.call(thumbsUl.children, li));
      });
    }
    if (main) {
      main.addEventListener('cl:slide', function (e) { mark(e.detail.index); });
    }
    function mediaIndex(id) {
      var s = slides();
      for (var k = 0; k < s.length; k++) {
        var mid = s[k].getAttribute('data-media-id') || '';
        if (mid.slice(-String(id).length) === String(id)) return k;
      }
      return -1;
    }

    /* ---- variante ---- */
    function paintAvailability(opts) {
      names.forEach(function (n, i) {
        radios.filter(function (r) { return r.name === n; }).forEach(function (r) {
          var test = opts.slice(); test[i] = r.value;
          var v = find(test);
          var ok = !!(v && v.available);
          r.classList.toggle('disabled', !ok);
        });
      });
    }
    function update(fromUser) {
      var opts = selected();
      var v = find(opts);
      names.forEach(function (n, i) {
        var grp = radios.filter(function (r) { return r.name === n; })[0];
        var box = grp && grp.closest('.product-form__input');
        var lbl = box && box.querySelector('[data-cl-opt-value]');
        if (lbl) lbl.textContent = opts[i] || '';
      });
      paintAvailability(opts);
      if (!v) {
        if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atc) { atc.disabled = !v.available; if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Sold out'; }
      if (fromUser) {
        try { history.replaceState({}, '', location.pathname + '?variant=' + v.id); } catch (e) {}
        if (v.featured_media && v.featured_media.id) {
          var k = mediaIndex(v.featured_media.id);
          if (k >= 0) goSlide(k);
        }
      }
      host.dispatchEvent(new CustomEvent('cl:variant', { bubbles: true, detail: { variant: v } }));
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { update(true); }); });

    /* ---- quantidade (+/-) do quantity-input do Shrine ---- */
    Array.prototype.forEach.call(host.querySelectorAll('.ce-quantity-input'), function (q) {
      var inp = q.querySelector('input.quantity__input');
      if (!inp) return;
      var minus = q.querySelector('button[name="minus"]');
      function paint() { var v = parseInt(inp.value, 10) || 1; if (minus) minus.classList.toggle('disabled', v <= (parseInt(inp.min, 10) || 1)); }
      Array.prototype.forEach.call(q.querySelectorAll('button[name="plus"], button[name="minus"]'), function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var v = (parseInt(inp.value, 10) || 1) + (b.name === 'plus' ? 1 : -1);
          inp.value = Math.max(parseInt(inp.min, 10) || 1, v);
          paint();
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      inp.addEventListener('change', paint);
      paint();
    });

    /* ---- app Kaching REAL no [data-cl-app-slot] (retrabalho 10-24, no lugar da replica) ----
       o mover do template poe o app block DENTRO do form unico; o app escreve quantidade/propriedades do kit
       nele e o submit (cl-ui.js) posta esse FormData. Com barras do app, a quantidade copiada some e o input
       dela (form=) fica disabled — senao o FormData leva duas "quantity". */
    var slot = host.querySelector('[data-cl-app-slot="kaching"]');
    /* retrabalho 10-30: [data-cl-vfb] = seletor de variante de reserva (Colore/Taglia) no lugar da replica do Rapi;
       some quando o app desenha as barras (que tem seletor por unidade) e volta se o app sumir */
    var vfb = host.querySelector('[data-cl-vfb]');
    if (slot) {
      var markApp = function () {
        var on = !!slot.querySelector('.kaching-bundles__bar');
        if (vfb) vfb.style.display = on ? 'none' : '';
        Array.prototype.forEach.call(host.querySelectorAll('.product-form__quantity'), function (q) { if (!slot.contains(q)) q.style.display = on ? 'none' : ''; });
        Array.prototype.forEach.call(host.querySelectorAll('input.quantity__input[name="quantity"]'), function (q) { if (!slot.contains(q)) q.disabled = on; });
      };
      markApp();
      if ('MutationObserver' in window) new MutationObserver(markApp).observe(slot, { childList: true, subtree: true });
    }
    /* gotas/cepillo (retrabalho 10-26): o cl-ui.js pergunta form.__clItems() no submit -> o lote do app
       (quantidade + __kaching_bundles do deal do operador), postado com ?kaching_bundles=true para o embed
       nao re-interceptar; null (app ainda sem barras) -> o FormData do form (1 un.) */
    var appForm = host.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    if (slot && appForm) {
      appForm.__clItems = function () {
        var kb = slot.querySelector('kaching-bundles-block');
        if (kb && typeof kb.items === 'function') {
          try { var its = kb.items(); if (its && its.length) return its; } catch (e) {}
        }
        return null;
      };
      appForm.__clKitUrl = '/cart/add.js?kaching_bundles=true';
    }

    /* ---- sticky ATC: aparece quando o ATC do buybox sai por cima da tela ---- */
    var st = host.querySelector('.ce-sticky-atc');
    if (st && atc) {
      if (st.getAttribute('data-after-scroll') === 'true' && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            var past = !x.isIntersecting && x.boundingClientRect.top < 0;
            st.style.transform = past ? 'translateY(0)' : '';
            st.classList.toggle('cl-sticky-on', past);
          });
        }).observe(atc);
      }
      Array.prototype.forEach.call(st.querySelectorAll('button'), function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); atc.click(); });
      });
    }
    if (radios.length) update(false);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cl-pdp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
